import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=049a2034"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=049a2034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports